export default __webpack_public_path__ + "static/media/gana.21024165.jpg";